export default "__VITE_ASSET__lNpanneU__"